"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.crunch = exports.uncrunch = void 0;
const crunch_1 = require("./crunch");
Object.defineProperty(exports, "crunch", {
  enumerable: true,
  get: function () {
    return crunch_1.crunch;
  }
});
const uncrunch_1 = require("./uncrunch");
Object.defineProperty(exports, "uncrunch", {
  enumerable: true,
  get: function () {
    return uncrunch_1.uncrunch;
  }
});